import { apiClient } from './client';

export interface ApprovalModuleCount { module: string; count: number; }

/** Human-readable labels for every module that writes into the shared approvals table (confirmed by inspecting every workflowEngine.createApproval() call site, not guessed). */
export const APPROVAL_MODULE_LABELS: Record<string, string> = {
  accounts_payable: 'Accounts Payable', accounts_receivable: 'Accounts Receivable', budget: 'Budgets', contracts: 'Contracts',
  employee_training: 'Training Requests', expense_claim: 'Expense Claims', grant: 'Grants', hr_request: 'HR Requests',
  income_record: 'Income Records', journal_entry: 'Journal Entries', leave: 'Leave Requests', logistics_request: 'Logistics Requests',
  partner_due_diligence: 'Partner Due Diligence', probation: 'Probation Reviews', programme: 'Programmes', project: 'Projects',
  project_amendment: 'Project Amendments', recruitment: 'Recruitment', staff_movement: 'Staff Movements', travel_request: 'Travel Requests',
  workforce_request: 'Workforce Requests',
};

export const approvalsApi = {
  mySummary: () => apiClient.get<{ data: ApprovalModuleCount[] }>('/api/approvals/my-summary'),
};
